import { Fragment } from "react";
import { CircleMarker, Polygon, Tooltip } from "react-leaflet";

// Auto-harvested OpenStreetMap amenities shown as toggleable map layers.
export const OSM_AMENITY_META = {
  osm_park: { color: "#22C55E", label: "Parks" },
  osm_bathroom: { color: "#8B5CF6", label: "Public Restrooms" },
  osm_parking: { color: "#EAB308", label: "Parking" },
};

const isLL = (lat, lng) => Number.isFinite(lat) && Number.isFinite(lng);

export default function OsmAmenityLayers({ data = {}, visible = {} }) {
  const { bathrooms = [], parking = [], parks = [] } = data || {};
  return (
    <>
      {visible.osm_park && parks.map((pk, i) => (!isLL(pk.lat, pk.lng) ? null : (
        <Fragment key={`osm-park-${i}`}>
          {Array.isArray(pk.polygon) && pk.polygon.length >= 3 && (
            <Polygon positions={pk.polygon} pathOptions={{ color: "#22C55E", fillColor: "#22C55E", weight: 1.5, fillOpacity: 0.18 }}>
              <Tooltip>{pk.name || "Park"}</Tooltip>
            </Polygon>
          )}
          <CircleMarker center={[pk.lat, pk.lng]} radius={6} pathOptions={{ color: "#fff", weight: 2, fillColor: "#22C55E", fillOpacity: 1 }}>
            <Tooltip>{pk.name || "Park"}</Tooltip>
          </CircleMarker>
        </Fragment>
      )))}
      {visible.osm_bathroom && bathrooms.map((b, i) => (!isLL(b.lat, b.lng) ? null : (
        <CircleMarker key={`osm-wc-${i}`} center={[b.lat, b.lng]} radius={5} pathOptions={{ color: "#fff", weight: 2, fillColor: "#8B5CF6", fillOpacity: 1 }}>
          <Tooltip>{b.name || "Public restroom"}</Tooltip>
        </CircleMarker>
      )))}
      {visible.osm_parking && parking.map((b, i) => (!isLL(b.lat, b.lng) ? null : (
        <CircleMarker key={`osm-park2-${i}`} center={[b.lat, b.lng]} radius={5} pathOptions={{ color: "#fff", weight: 2, fillColor: "#EAB308", fillOpacity: 1 }}>
          <Tooltip>{b.name || "Parking"}</Tooltip>
        </CircleMarker>
      )))}
    </>
  );
}
